import React from 'react';
import { Box, Tab, Typography } from '@material-ui/core';

import useStyles from './styles';

export const TabTitle = props => {
  const classes = useStyles(props);
  const { index, title, ammount, ...otherProps } = props;

  return (
    <Tab
      id={`dash-tab-${index}`}
      aria-controls={`dash-tabpanel-${index}`}
      label={
        <Box className={classes.btnContainer}>
          <Box className="tab-content">
            <Typography className="tab-text" variant="overline">
              {title}
            </Typography>
            {ammount > 0 ? (
              <Typography
                className="tab-ammount"
                component="label"
                variant="overline"
              >
                {ammount > 9 ? '+9' : ammount}
              </Typography>
            ) : null}
          </Box>
        </Box>
      }
      {...otherProps}
    />
  );
};

export const TabPanel = props => {
  const { children, active, index, ...otherProps } = props;

  return (
    <Box
      role="tabpanel"
      id={`dash-tabpanel-${index}`}
      aria-labelledby={`dash-tab-${index}`}
      {...otherProps}
    >
      {active === index ? children : null}
    </Box>
  );
};
